let calismaBilgi = null;
const setAcilanCalismaBilgi = (bilgi) => {
  calismaBilgi = bilgi;
};

const getAcilanCalismaBilgi = () => calismaBilgi;

export { setAcilanCalismaBilgi, getAcilanCalismaBilgi };
